import React, { useEffect, useState } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { useNavigate } from 'react-router-dom';
import Card from "components/card";
import { MdClose } from "react-icons/md";

const QRScanner = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const scanner = new Html5QrcodeScanner('reader', {
      qrbox: {
        width: 250,
        height: 250,
      },
      fps: 5,
    });

    const success = (result) => {
      scanner.clear();
      if (result.startsWith('WH-')) { // Checks if it's a warehouse ID
        navigate('/admin/warehouse-view', { 
          state: { selectedRecordId: result } // Passes the ID through state
        });
      } else {
        setError('Invalid warehouse QR code');
      }
    };

    const error = (err) => {
      console.warn(err);
    };

    scanner.render(success, error);

    return () => {
      scanner.clear();
    };
  }, [navigate]);

  return (
    <div className="mt-5 h-full">
      <Card extra={"w-full h-full p-4"}>
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-xl font-bold text-navy-700 dark:text-white">
            Scan Warehouse QR Code
          </h3>
          <button
            onClick={() => navigate('#')}
            className="rounded-full bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-navy-600"
          >
            {/* <MdClose className="h-6 w-6" /> */}
          </button>
        </div>

        <div className="max-w-[500px] mx-auto">
          {error && (
            <div className="mb-4 rounded-lg bg-red-100 p-4 text-red-700">
              {error}
            </div>
          )}
          
          <div id="reader" className="w-full"></div>
          
          <p className="mt-4 text-center text-sm text-gray-600 dark:text-gray-400">
            Position the warehouse QR code within the frame to scan
          </p>
        </div>
      </Card>
    </div>
  );
};

export default QRScanner; 